import { Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoginEndconsumerResponseData, LoginTeamResponseData } from "../../models/user.model";
import { UserService } from "../../services/user.service";
import { NgxSmartModalService } from "ngx-smart-modal";

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss'
})
export class OtpComponent implements OnInit {
  private _userService: UserService = inject(UserService);
  private _ngxSmartModalService: NgxSmartModalService = inject(NgxSmartModalService);

  @Input() giPantMode!: boolean;
  @Input() henterPantMode!: boolean;
  @Input() phoneNumber!: string;

  @Output() getProject: EventEmitter<void> = new EventEmitter<void>;

  initialPhoneNumber!: string;
  timerDisplay: string = '05:00';
  verifyLoading!: boolean;
  verifyError!: boolean;
  updatingPhoneLoading!: boolean;
  updatingPhoneError!: boolean;
  changingNumber: boolean = false;

  isResendEnabled: boolean = false;
  private _timer: any;
  error!: boolean;
  loading!: boolean;
  otpVerificationDisplay!: boolean;

  @ViewChild("otp1", {static: false}) otp1!: ElementRef;
  @ViewChild("otp2", {static: false}) otp2!: ElementRef;
  @ViewChild("otp3", {static: false}) otp3!: ElementRef;
  @ViewChild("otp4", {static: false}) otp4!: ElementRef;
  @ViewChild("otp5", {static: false}) otp5!: ElementRef;
  @ViewChild("otp6", {static: false}) otp6!: ElementRef;

  constructor() {
  }

  ngOnInit() {
    this.initialPhoneNumber = this.phoneNumber;

    setTimeout(() => {
      this.otp1.nativeElement.focus();
    }, 200);

    this.otpRequest();
  }

  resendOTP(): void {
    if (this.isResendEnabled) {
      this.isResendEnabled = false;
      this.startTimer(5);
      this.otpRequest();
    }
  }

  otpRequest(): void {
    this.error = false;
    this.loading = true;

    this._userService.otpRequest().subscribe(result => {
      this.otpVerificationDisplay = true;
      this.startTimer(5);
      this.loading = false;
    }, error => {
      // if (error.error.error.includes('400 Client Error: Bad Request')) {
      //   // TODO
      // }
      this.error = true;
      this.loading = false;
      this.phoneNumber = this.initialPhoneNumber;
    });
  }

  startTimer(minutes: number) {
    let timeInSeconds = minutes * 60;

    this._timer = setInterval(() => {
      if (timeInSeconds <= 0) {
        clearInterval(this._timer);
        this.isResendEnabled = true; // Enable resend button
      } else {
        timeInSeconds--;
        const minutes: number = Math.floor(timeInSeconds / 60);
        const seconds: number = timeInSeconds % 60;
        this.timerDisplay = `${this.pad(minutes)}:${this.pad(seconds)}`;
      }
    }, 1000);
  }

  pad(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
  }

  moveFocus(currentInput: HTMLInputElement, nextInput: HTMLInputElement): void {
    if (currentInput.value.length === currentInput.maxLength) {
      nextInput.focus();
    }
  }

  moveBack(event: KeyboardEvent, previous: HTMLInputElement): void {
    const target = event.target as HTMLInputElement;
    if (event.key === 'Backspace' && !target.value) {
      previous.focus();
    }
  }

  checkCode(): boolean {
    if (!this.otp1 || !this.otp2 || !this.otp3 || !this.otp4 || !this.otp5 || !this.otp6) return false;
    const otp1Value = this.otp1.nativeElement.value;
    const otp2Value = this.otp2.nativeElement.value;
    const otp3Value = this.otp3.nativeElement.value;
    const otp4Value = this.otp4.nativeElement.value;
    const otp5Value = this.otp5.nativeElement.value;
    const otp6Value = this.otp6.nativeElement.value;

    return otp1Value && otp2Value && otp3Value && otp4Value && otp5Value && otp6Value;
  }

  verify(): void {
    if (this.verifyLoading) return;
    this.verifyError = false;
    this.verifyLoading = true;
    const otp1Value = this.otp1.nativeElement.value;
    const otp2Value = this.otp2.nativeElement.value;
    const otp3Value = this.otp3.nativeElement.value;
    const otp4Value = this.otp4.nativeElement.value;
    const otp5Value = this.otp5.nativeElement.value;
    const otp6Value = this.otp6.nativeElement.value;

    if (!otp1Value || !otp2Value || !otp3Value || !otp4Value || !otp5Value || !otp6Value) return;

    const requestData: {otp_code: string} = {
      otp_code: otp1Value + otp2Value + otp3Value + otp4Value + otp5Value + otp6Value
    }

    this._userService.otpVerify(requestData).subscribe(result => {
      // this._ngxSmartModalService.getModal('endConsumerRegModal').close(); // TODO

      if (this.giPantMode) {
        this._ngxSmartModalService.getModal('endConsumerRegModal').close();
      }

      if (this.henterPantMode) {
        this._ngxSmartModalService.getModal('otpModal').close();
        this.getProject.emit();
      }

      this.verifyLoading = false;
    }, error => {
      // TODO
      this.verifyError = true;
      this.verifyLoading = false;
    });
  }

  changeNumber(): void {
    this.updatingPhoneError = false;
    this.updatingPhoneLoading = true;

    const updateData: {phone_number: string} = {
      phone_number: this.phoneNumber
    }

    this._userService.updateTeam(updateData).subscribe(result => {
      const loginData: LoginEndconsumerResponseData | LoginTeamResponseData | '' = this._userService.get();
      if(loginData && loginData.user) {
        loginData.user.profile.phone_number =  this.phoneNumber;
        this._userService.set(loginData);
      }

      this.changingNumber = false;
      this.updatingPhoneLoading = false;
    }, error => {
      this.updatingPhoneError = true;
      this.updatingPhoneLoading = false;
    });
  }
}
